export class ChangePasswordDTO {
    constructor(email, password, otp) {
      this.email = email;
      this.password = password;
      this.otp = otp;
    }
  }